/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

import {
  InfrastructureButton,
} from 'src/components/ViewSpinner/components/RenderSvg/components/InfrastructureType/components/InfrastructureButton';
import Box from '@mui/material/Box';
import { IInfrastructureTypeVideo } from '../../types';
import { useStyles } from '../../styles';

export const InfrastructureVideoLoop: React.FC<IInfrastructureTypeVideo> = ({
  data,
}) => {
  const styles = useStyles({});

  return (
    <Box display="flex" flexDirection="column" gap="12px">
      <div className={`${styles.wrapperInfrastructureType} loop-video-wrapper`}>
        <video autoPlay loop controls playsInline width="100%" height="400px">
          <source src={data['infrastructure.src']} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <InfrastructureButton data={data} />
    </Box>
  );
};
